﻿import { Component, JSXElement, createSignal, Show } from 'solid-js';
import IconButton from '../IconButton/IconButton';
import { BtnClasses } from '../../types/common';

const DEFAULT_ITEM_LIMIT = 5;

export interface LimitVisibleItemsChevronProps {
  itemLimit?: number;
  title?: string;
  className?: string;
  children?: JSXElement[] | undefined;
  'data-cy'?: string;
}

const LimitVisibleItemsChevron: Component<LimitVisibleItemsChevronProps> = (
  props
): JSXElement => {
  const [showAll, setShowAll] = createSignal(false);

  const getLimit = (): number => props.itemLimit ?? DEFAULT_ITEM_LIMIT;
  const children = (): JSXElement[] => props.children ?? [];
  const hasMore = (): boolean => children().length > getLimit();
  const visibleItems = (): JSXElement[] =>
    showAll() || !hasMore() ? children() : children().slice(0, getLimit());

  return (
    <div data-testid={props['data-cy'] || 'limit-visible-chevron'}>
      <Show when={hasMore()}>
        <div
          class={`row-distribute px-2 ${props.className ?? ''}`}
          onClick={() => setShowAll(!showAll())}
          style={{ cursor: 'pointer' }}
        >
          <p class="flex-grow-1 text-bold">{props.title ?? ''}</p>
          <IconButton
            icon={showAll() ? 'tc-icon-chevron-up' : 'tc-icon-chevron-down'}
            color={BtnClasses.Tertiary}
            shape="icon-circle"
          />
        </div>
      </Show>
      {visibleItems()}
    </div>
  );
};

export default LimitVisibleItemsChevron;
